import { render } from "./BaseSwitch.vue?vue&type=template&id=4fe9948e&ts=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts"

import "./BaseSwitch.vue?vue&type=style&index=0&id=4fe9948e&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__